<template>
    <div class="loading-container">
        <loading :active="updating" :is-full-page="false" />
        <div class="task-body">
            <router-link :to="link">
                <button class="medium">Manage Entity Provider Links</button>
            </router-link>
            <p>{{ item.description }}</p>
        </div>
        <div class="task-actions">
            <button @click="ignore">Clear</button>
        </div>
    </div>
</template>
<script setup>
import TaskService from '@/services/manage/taskService'
import { request } from '@/utils/request'
import EntityTypes from '@/utils/entityTypes'
import { asyncComputed } from '@/utils/asyncComputed'
import { computed, inject } from 'vue'

const props = defineProps({
    item: {
        type: Object,
        required: true,
    },
})

const entityProviderId = asyncComputed(() =>
    request.get(`/api/manage/entityproviderids/${props.item.secondaryEntityId}`, {})
)

const link = computed(
    () => `/manage${EntityTypes.getLink(props.item.primaryEntityType, props.item.primaryEntityId)}/providers`
)

const updating = computed(() => entityProviderId.updating)

const flash = inject('flash')

async function ignore() {
    await TaskService.complete(props.item)
    flash('Task cleared.', 'success')
}
</script>
